/* eslint-disable import/no-anonymous-default-export */
import type { AxiosResponse } from "axios";
import apiClient from "@utilities/apiClient";
import EndpointsConst from "@consts/EndpointsConst";

type AddFAQPayload = Omit<FAQ, "id">;

class FAQService {
  /**
   * [POST]
   * Submits a new faq to the database
   * @param faq - The FAQ's question and answer
   */
  addFAQ(faq: AddFAQPayload): Promise<AxiosResponse> {
    return apiClient.post(EndpointsConst.API.FAQ.ADD_FAQ, faq);
  }

  /**
   * [DELETE]
   * Deletes FAQ from database
   * @param id - The id of the FAQ to delete
   */
  deleteFAQ(id: number): Promise<AxiosResponse> {
    return apiClient.delete(EndpointsConst.API.FAQ.DELETE_FAQ, {
      params: { id },
    });
  }

  /**
   * [GET]
   * Retrieves all FAQs from database
   */
  getAllFAQs(): Promise<AxiosResponse<FAQ[]>> {
    return apiClient.get(EndpointsConst.API.FAQ.GET_ALL_FAQS);
  }

  /**
   * [GET]
   * Retrieves FAQ by Id from database
   * @param id - The id of the FAQ to retrieve
   */
  getFAQById(id: number): Promise<AxiosResponse<FAQ>> {
    return apiClient.get(EndpointsConst.API.FAQ.GET_FAQ_BY_ID, {
      params: { id },
    });
  }
}

export default new FAQService();
